import React, { useEffect, useState } from "react";

import { checkAdminAccess, useAdminUserContext, useNavigate, useParams } from "utils";

import { ErrorBoundary, MainPage, Tabs } from "components";

import { Exceptions } from "pages/admin/redzones/Exceptions";
import { ShapefileUpload } from "pages/admin/redzones/ShapefileUpload";

export const Redzones = () => {
  const { section } = useParams();
  const { user } = useAdminUserContext();

  const [currentSection, setCurrentSection] = useState(false);
  const navigate = useNavigate();

  const tabList = [
    {
      name: "Exceptions",
      key: "exceptions",
      component: <Exceptions />,
    },
    {
      name: "Shapefile Uploads",
      key: "shapefile-uploads",
      component: <ShapefileUpload />,
    },
  ];

  const getTabItems = () =>
    tabList.map((tab) => ({
      label: tab.name,
      key: tab.key,
      children: <ErrorBoundary>{tab.component}</ErrorBoundary>,
      disabled: !checkAdminAccess(user.role, `redzones/${tab.key}`),
    }));

  useEffect(() => {
    setCurrentSection(section);
  }, [section]);

  return (
    <MainPage pageName={"admin"}>
      <Tabs activeKey={currentSection} size="small" onChange={(v) => navigate({ pathname: `/redzones/${v}` }, { replace: true })} items={getTabItems()} />
    </MainPage>
  );
};
